import {Component, Input} from '@angular/core';
import {ActivityStatus} from '../../domain/activity-status.model';
import {DevicePlacement} from '../../domain/device-placement.model';

@Component({
  selector: 'cm-device-placement-icon',
  template: `
    <span
      [ngClass]="{
        'platform-label platform-label--mobile': placement === DevicePlacement.MOBILE || placement === DevicePlacement.MW
       , 'platform-label platform-label--desktop': placement === DevicePlacement.DESKTOP}">
      <i class="far fa-mobile" *ngIf="placement === DevicePlacement.MOBILE || placement === DevicePlacement.MW" matTooltip="Mobile"></i>
      <i class="far fa-desktop" *ngIf="placement === DevicePlacement.DESKTOP" matTooltip="Desktop"></i> 
  </span>`
})
export class DevicePlacementIconComponent {

  @Input()
  public placement: DevicePlacement;

  public DevicePlacement = DevicePlacement;

}
